export const timeStringToSeconds = (time: string): number => {
  const parts = time.split(":").map(Number);
  if (parts.length === 2) {
    // Format is "MM:SS"
    const [minutes, seconds] = parts;
    return minutes * 60 + seconds;
  } else {
    // Format is "HH:MM:SS"
    const [hours, minutes, seconds] = parts;
    return hours * 3600 + minutes * 60 + seconds;
  }
};

export const formatFullTime = (secs: number, toggleHours = false): string => {
  const hours = Math.floor(secs / 3600)
    .toString()
    .padStart(2, "0");
  const minutes = Math.floor((secs % 3600) / 60)
    .toString()
    .padStart(2, "0");
  const seconds = Math.floor(secs % 60)
    .toString()
    .padStart(2, "0");

  if (toggleHours) {
    return hours === "00" ? `${minutes}:${seconds}` : `${hours}:${minutes}:${seconds}`;
  }

  return `${hours}:${minutes}:${seconds}`;
};

export const formatMsToTime = (ms: number, toggleHours = false): string => {
  const totalSeconds = Math.floor(ms / 1000);
  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
  const seconds = String(totalSeconds % 60).padStart(2, "0");

  if (toggleHours) {
    return hours === "00" ? `${minutes}:${seconds}` : `${hours}:${minutes}:${seconds}`;
  }
  return `${hours}:${minutes}:${seconds}`;
};

export type HmsUnitLabels = {
  hours: string;
  minutes: string;
  seconds: string;
};

export const formatTimeToHms = (time: string, units: HmsUnitLabels): string => {
  const [hours, minutes, seconds] = time.split(":").map(Number);

  const parts: string[] = [];
  if (hours > 0) parts.push(`${hours}${units.hours}`);
  if (hours > 0 || minutes > 0) parts.push(`${minutes}${units.minutes}`);
  parts.push(`${seconds}${units.seconds}`);

  return parts.join(" ");
};
